var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gallery-container",attrs:{"dir":"rtl"}},[_c('div',{staticClass:"gallery-card"},[_c('div',{staticClass:"images-list"},_vm._l((_vm.images),function(img){return _c('div',{key:img.name,staticClass:"image-item"},[_c('img',{attrs:{"src":img.src,"alt":img.name}})])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }